import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const today = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function DistributionDefault() {
  const [week, setWeek] = useState(today);
  const onWeekChange = useCallback((event) => setWeek(event.target.value), []);

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [noActionAgent, setNoActionAgent] = useState(false);
  const onNoActionAgentChange = useCallback(
    (event) => setNoActionAgent(event.target.checked),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Week Of"
          type="date"
          value={week}
          size="small"
          onChange={onWeekChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <div className="col-span-2">
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={noActionAgent}
                onChange={onNoActionAgentChange}
                color="primary"
              />
            }
            label="Include No Action Agents"
          />
        </div>
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Distributor"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Group"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Alphabetically"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Distribution Default Report"
        groupBy={orderBy === 1 ? "groupname" : null}
        getUrl={() => "/Reports/Report_DistributionDefault"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          DateWeek: week,
          Distributor: distributor,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          NoActionAgent: noActionAgent,
          OrderBy: orderBy,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const grossTW =
              item.weeklySports + item.weeklyHorses + item.weeklyCasino;
            const grossMakeUp = item.makeUp + grossTW;
            const comm = item.commSports + item.commHorses + item.commCasino;
            const distWeek =
              item.toDistSports + item.toDistHorses + item.toDistCasino;

            return {
              ...item,
              grossTW,
              grossMakeUp: grossMakeUp < 0 ? grossMakeUp : 0,
              comm,
              distWeek,
              distributor: item.distributor ?? "<house>",
            };
          })
        }
        getTotals={(data) => ({
          agent: "Total",
          makeUp: data.reduce((acc, item) => acc + item.makeUp, 0),
          grossTW: data.reduce((acc, item) => acc + item.grossTW, 0),
          grossMakeUp: data.reduce((acc, item) => acc + item.grossMakeUp, 0),
          comm: data.reduce((acc, item) => acc + item.comm, 0),
          distWeek: data.reduce((acc, item) => acc + item.distWeek, 0),
          newMakeUp: data.reduce((acc, item) => acc + item.newMakeUp, 0),
          pBalance: data.reduce((acc, item) => acc + item.pBalance, 0),
          nBalance: data.reduce((acc, item) => acc + item.nBalance, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="makeUp"
          dataFormat={decimalInvertedReportFormatter}
        >
          Make Up
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="grossTW"
          dataFormat={decimalInvertedReportFormatter}
        >
          Gross TW
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agentType">
          Agent Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="grossMakeUp"
          dataFormat={decimalInvertedReportFormatter}
        >
          Gross - Make Up
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="comm"
          dataFormat={decimalInvertedReportFormatter}
        >
          Comm
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="distWeek"
          dataFormat={decimalInvertedReportFormatter}
        >
          Dist Week
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="newMakeUp"
          dataFormat={decimalInvertedReportFormatter}
        >
          New Make Up
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="pBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          Prev Balance
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="nBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          New Balance
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="distributor">
          Distributor
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default DistributionDefault;
